import { DefaultService } from '@/services/DefaultService';

export default class TurnoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    save(turno) {
        return this._http.post(`${this._env}/promotor/shifts`, turno, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findVendas(id) {
        return this._http.get(`${this._env}/ven/promotor/shifts/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findPromotor(id) {
        return this._http.get(`${this._env}/pro/promotor/shifts/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAgro(id) {
        return this._http.get(`${this._env}/agro/promotor/shifts/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findDespesas(id) {
        return this._http.get(`${this._env}/des/promotor/shifts/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    updateSituacaoVendas(turno) {
        return this._http.post(`${this._env}/ven/promotor/shifts/update-situacao`, turno, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    updateSituacaoPromotor(turno) {
        return this._http.post(`${this._env}/pro/promotor/shifts/update-situacao`, turno, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    updateSituacaoAgro(turno) {
        return this._http.post(`${this._env}/agro/promotor/shifts/update-situacao`, turno, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    updateSituacaoDespesas(turno) {
        return this._http.post(`${this._env}/des/promotor/shifts/update-situacao`, turno, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    deleteVendas(id) {
        return this._http.delete(`${this._env}/ven/promotor/shifts/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    deletePromotor(id) {
        return this._http.delete(`${this._env}/pro/promotor/shifts/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    deleteAgro(id) {
        return this._http.delete(`${this._env}/agro/promotor/shifts/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    deleteDespesas(id) {
        return this._http.delete(`${this._env}/des/promotor/shifts/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    updateSituacao(turno) {
        return this._http.post(`${this._env}/promotor/shifts/updatesituacao`, turno, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllVendas(column, order,page = 0, limit = 50, ...params) {
        return this._http.get(encodeURI(`${this._env}/ven/promotor/shifts.json?page=${page}&limit=${limit}&column=${column}&order=${order}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllPromotor(column, order,page = 0, limit = 50, ...params) {
        return this._http.get(encodeURI(`${this._env}/pro/promotor/shifts.json?page=${page}&limit=${limit}&column=${column}&order=${order}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllAgro(column, order,page = 0, limit = 50, ...params) {
        return this._http.get(encodeURI(`${this._env}/agro/promotor/shifts.json?page=${page}&limit=${limit}&column=${column}&order=${order}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllDespesas(column, order,page = 0, limit = 50, ...params) {
        return this._http.get(encodeURI(`${this._env}/des/promotor/shifts.json?page=${page}&limit=${limit}&column=${column}&order=${order}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllPeriodosByTurnoVendas(idturno, page = 0, limit = 20, column = 'descricao', order = 'asc', ...params) {
        return this._http.get(`${this._env}/ven/promotor/shifts/${idturno}/period.json?page=${page}&limit=${limit}&column=${column}&order=${order}&param=${params}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllPeriodosByTurnoPromotor(idturno, page = 0, limit = 20, column = 'descricao', order = 'asc', ...params) {
        return this._http.get(`${this._env}/pro/promotor/shifts/${idturno}/period.json?page=${page}&limit=${limit}&column=${column}&order=${order}&param=${params}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllPeriodosByTurnoAgro(idturno, page = 0, limit = 20, column = 'descricao', order = 'asc', ...params) {
        return this._http.get(`${this._env}/agro/promotor/shifts/${idturno}/period.json?page=${page}&limit=${limit}&column=${column}&order=${order}&param=${params}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllPeriodosByTurnoDespesas(idturno, page = 0, limit = 20, column = 'descricao', order = 'asc', ...params) {
        return this._http.get(`${this._env}/des/promotor/shifts/${idturno}/period.json?page=${page}&limit=${limit}&column=${column}&order=${order}&param=${params}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

}